import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./Supplier.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Row, Col, Container, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { FaTrash, FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"
import { MdAdd } from "react-icons/md";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { FaFileDownload, FaFileUpload } from 'react-icons/fa';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';



const SuppliersAccount = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
     const [rows1, setRows1] = useState([{ bankName: "", accName: "", accNo: "" }]);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [uploadShow2, setUploadShow2] = useState(false);
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadLoading2, setUploadLoading2] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);

  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  

  const handleClose1 = () => {
    setShow1(false);
  };

const handleShow1 = (item) => {
  setSuppliers(item);
  setFullName1(item.name || "");
  setEmail1(item.email || "");
  setAddress1(item.address || "");
  setPhoneNo(item.phone_number || "");
  setShow1(true);

  setRows1(
  item.banks?.map(b => ({
    bankName: b.bank_name || "",
    accName: b.account_name || "",
    accNo: b.bank_account || "",
  })) || []
);
};


console.log(rows1);

const FetchSuppliers = async () => {
  setBenLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
    const results = response.data?.data;
    const resultx = response.data?.data?.total;
    // setTotalEntries(resultx);
    setTableData(results);
    const total = response.data?.data?.last_page || 1;
    // setTotalPages(total);

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          console.log(errorMessage);
          setError(errorMessage)
        }
      }
      setTableData([]);
    }
  } finally {
    setBenLoading(false);
  }

};

useEffect(() => {
  if (bearer) {
    FetchSuppliers();
  }
}, [bearer, currentPage]);




const handleShow = () => setShow(true);
const handleClose = () => setShow(false);

    // const handleChange = (option) => {
    //         setSelectedOption(option);
    //         console.log("Selected:", option);
    //     };
    function getLoanColors(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;

  return {
    backgroundColor: `hsl(${hue}, 70%, 90%)`, 
    color: `hsl(${hue}, 70%, 30%)`,   
  };
}


  const [rows, setRows] = useState([{ bankName: "", accName: "", accNo: "" }]);
 

  const addRow = () =>
    setRows([...rows, { bankName: "", accName: "", accNo: "" }]);
  
  const addRow1 = () =>
    setRows1([...rows1, { bankName: "", accName: "", accNo: "" }]);

  const deleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  const deleteRow1 = (index) => {
    const updatedRows1 = rows1.filter((_, i) => i !== index);
    setRows1(updatedRows1);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  const handleChange1 = (index, field, value) => {
    const updatedRows1 = [...rows1];
    updatedRows1[index][field] = value;
    setRows1(updatedRows1);
  };
  
  const handleUploadShow = () => setUploadShow(true);
  const handleUploadClose = () => {
    setUploadShow(false);
    setFile(null);
  };
  const handleUploadShow2 = (item) => {
    setUploadShow2(true);
    setSuppliers(item);
  };
const handleUploadClose2 = () => {
  setUploadShow2(false);
  setFile1(null);
};

const handleFileChange = (event) => {
  const file = event.target.files[0];
  setFile(file);
};

const handleFileChange1 = (event) => {
  const file = event.target.files[0];
  setFile1(file);
};


const updateBeneficiary = async () => {

  setUploadLoading(true);
  try {
    const bankAccounts = rows1.map(item => item.accNo);
    const accountNames = rows1.map(item => item.accName);
    const bankNames = rows1.map(item => item.bankName);

    const response = await axios.post(`${BASE_URL}/beneficiaryaccounts/update`,
      {
        name: fullName1,
        email: email1,
        phone_number: phoneNo,
        address: address1,
        bank_account: bankAccounts,
        account_name: accountNames,
        bank_name: bankNames,
        id: suppliers.id
       
      },
      { headers }
    );
    handleClose1();
    FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    })
    // .then(() => {
    //   window.location.reload();
    // });
    console.log(response.data.message)
    setUploadLoading(false);
} catch (error) {
  let errorMessage = error.response?.data?.message;
  // let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log("error", errorMessage);
          }
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: errorMessage,
          });
      }
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler = async () => {
  if (!file) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose(); 
      return; 
    }

  setUploadLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    window.location.reload();

    handleUploadClose();
    setFile("");
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading(false);
  }
};

const uploadExcelHandler1 = async () => {
  if (!file1) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Please select a file to upload',
    });
    return;
  }

    // Confirmation alert before upload
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this file?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel",
    });
  
    if (!result.isConfirmed) {
      handleUploadClose2(); 
      return; 
    }

  setUploadLoading2(true);
  try {
    const formData = new FormData();
    formData.append('file', file1);
    formData.append('beneficiary_id', suppliers.id);

    const response = await axios.post(
      `${BASE_URL}/beneficiary/upload_beneficiary_accounts`, 
      formData, 
      { headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`
        } });

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message || 'File uploaded successfully',
    });
    handleUploadClose2();
    setFile1("");
    FetchSuppliers();
  } catch (error) {
    let errorMessage;

    if (error.response && error.response.data) {
      errorMessage = typeof error.response.data.message === 'object'
        ? JSON.stringify(error.response.data.message)
        : error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unexpected error occurred while uploading the file';
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setUploadLoading2(false);
  }
};

const createBeneficiary = async () => {
  setLoading(true);
  try {
     const bankAccounts = rows.map(item => item.accNo);
    const accountNames = rows.map(item => item.accName);
    const bankNames = rows.map(item => item.bankName);
    const response = await axios.post(`${BASE_URL}/beneficiary/add_new`,
      {
        name: fullName,
        email: email,
        phone_number: phone,
        address: address,
        bank_name: bankNames,
        account_name: accountNames,
        bank_account: bankAccounts
      },
      { headers }
    );
    console.log(response.data.message);
    setFullName('');
    setEmail('');
    setPhone('');
    setAddress('');
    setBankName('');
    setAccName('');
    setAccNo('');
    FetchSuppliers();
    handleClose();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    console.log(response.data.message);

  } catch (error) {
    let errorMessage;

    // Attempt to extract the error message
    if (error.response && error.response.data) {
      // If message is an object, attempt to stringify it
      if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      } else {
        errorMessage = error.response.data.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = "An unexpected error occurred";
    }

    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 //delete function
 const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this member.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/beneficiary/delete?id=${id}`, { headers });
    FetchSuppliers();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
   
    setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      // toast.error(errorMessage)
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};


const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const filteredData = tableData.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));
const totalEntries = filteredData.length;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};




        
  return (
    <div >
        <HeaderNav />


{/* for Add New Supplier/Contractor*/}

<Modal show={show} onHide={handleClose} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Supplier/Contractor</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Row>
          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </Col>

          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Col>

          <Col>
            <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Col>
        </Row>
      </Form.Group>

      <Form.Group>
        <Container fluid style={{ marginTop: "40px" }} className={classes.wrapper}>
          <h6 className={classes.headerText} style={{ textAlign: "left" }}>Add Bank Accounts</h6>

          <div className="table-responsive">
            <table className={classes.customtable}>
              <thead>
                <tr>
                  <th>Bank Name</th>
                  <th>Account Name</th>
                  <th>Account Number</th>
                  <th style={{ backgroundColor: "unset" }} className="text-center">
                    <button type="button" style={{ backgroundColor: "unset" }} className={classes.plusbtn} onClick={addRow}>
                      <FaPlus size={12} color="white" style={{ cursor: "pointer" }} />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.bankName}
                        onChange={(e) => handleChange(index, "bankName", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accName}
                        onChange={(e) => handleChange(index, "accName", e.target.value)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={row.accNo}
                        onChange={(e) => handleChange(index, "accNo", e.target.value)}
                      />
                    </td>
                    <td className="text-center">
                      <button type="button" style={{ backgroundColor: "unset" }} className={classes.btntrash} onClick={() => deleteRow(index)}>
                        <img src={DeleteIcon} alt="Delete" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer style={{ marginRight: "14px" }}>
    <Button variant="danger" onClick={handleClose}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={createBeneficiary}>
      Create Beneficiary
    </Button>
  </Modal.Footer>
</Modal>


      
    
<Modal show={show1} onHide={handleClose1} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Suppliers</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
      <Row>
        <Col>
        <Form.Label style={{ marginTop: 10, fontSize: "12px" }}>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Name"
          value={fullName1}
          onChange={(e) => setFullName1(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 10, fontSize: "12px" }}>Email</Form.Label>
        <Form.Control
          type="text"
          placeholder="Email"
          value={email1}
          onChange={(e) => setEmail1(e.target.value)}
        />
        </Col>
      </Row>

      <Row>
        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Phone Number</Form.Label>
        <Form.Control
          type="text"
          placeholder="Phone Number"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
        />
        </Col>

        <Col>
        <Form.Label style={{ marginTop: 20, fontSize: "12px" }}>Address</Form.Label>
      <Form.Control
          type="text"
          placeholder="Phone Number"
          value={address1}
          onChange={(e) => setAddress1(e.target.value)}
        />
        </Col>
      </Row>
        
      </Form.Group>

      {/* <div style={{display: "flex", gap: 30, alignItems: "center", justifyContent: "center" }}>
      <Col xs={10}>
        <h5 style={{ marginTop: "0px", textAlign: "center" }}>Add Bank Accounts</h5>
        </Col>

        <Col xs={2}>
        <Button style={{display: "flex", flexDirection: "column", alignItems: "flex-end" , justifyContent: "flex-end", textAlign: "right"}} variant="primary" onClick={addRow}>
          
          <FaPlus /> 
        </Button>
        </Col>
      </div> */}

      <Form.Group>
      <Container fluid style={{marginTop: "40px"}} className={classes.wrapper}>
      <h6 className={classes.headerText} style={{textAlign: "left"}}>Add Bank Accounts</h6>

      <div className="table-responsive">
      <table className={classes.customtable}>
        <thead>
          <tr>
            <th>Bank Name</th>
            <th>Account Name</th>
            <th>Account Number</th>
            <th style={{backgroundColor: "unset"}} className="text-center">
              <button type="button" style={{backgroundColor: "unset"}} className={classes.plusbtn} onClick={addRow1}>
              <FaPlus
              size={12}
              color="white"
              style={{ cursor: "pointer" }}
            />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows1.map((row, index) => (
            <tr key={index}>
              <td>
                <Form.Control
                  type="text"
                  value={row.bankName}
                  onChange={(e) =>
                    handleChange1(index, "bankName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accName}
                  onChange={(e) =>
                    handleChange1(index, "accName", e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.accNo}
                  onChange={(e) =>
                    handleChange1(index, "accNo", e.target.value)
                  }
                />
              </td>
              <td className="text-center">
                <button type="button" style={{backgroundColor: "unset"}} className={classes.btntrash} onClick={() => deleteRow1(index)}>
                <img src={DeleteIcon}/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </Container>
      </Form.Group>
 
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={updateBeneficiary}>
     Update Benficiary
    </Button>

  </Modal.Footer>
</Modal>

<Modal show={uploadShow2} onHide={handleUploadClose2} size="lg" animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Upload Account</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row>
        <Col md={4}>
          <button  className={classes.customButton1}>
            <a href="https://account-api.patna.ng/api/v1/download_suppliers_accounts_template" download>
              Download Account Template
            </a>
          </button>
        </Col>
        <Col md={5}>
          <Form.Control
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange1}
          />
        </Col>
        <Col md={3}>
          <Button className={classes.customButton} onClick={uploadExcelHandler1}>
          Save Account
          </Button>
        </Col>
      </Row>    
    </Form>
  </Modal.Body>
  <Modal.Footer style={{marginRight: "14px"}}>
    <Button variant="danger" onClick={handleUploadClose2}>
      Go back
    </Button>
    {/* <Button className={classes.customButton} onClick={uploadExcelHandler1}>
     Update Benficiary
    </Button> */}
  </Modal.Footer>
</Modal>

<Modal show={uploadShow} onHide={handleUploadClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel File</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{padding: 0}}>
                <Form style={{ marginTop: 5 }}>
               
                  <Form.Group style={{padding: 10,}}>
                  {/* <button  className={classes.customButton1} >
                  <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                  <img src={download} alt="download" /> Download Template
                    </a>
                </button> */}
                </Form.Group>
                  {/* <hr className={classes.downline} /> */}


                  <Form.Group style={{padding: 10}} className="mb-3" controlId="exampleForm.ControlInput2">
                    <Form.Label>Select Excel File</Form.Label>
                    <Form.Control
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                    />
                    <div style={{ marginTop: 10 }} />
                  </Form.Group>

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleUploadClose}>
                  Go back
                </Button>
                <Button  className={classes.customButton}  onClick={uploadExcelHandler}>
                  Upload File
                </Button>
              
              </Modal.Footer>
            </Modal>
            {uploadLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div>
          <div style={{}} className={classes.headtxt}>
            <h3 className={classes.topText}>Manage Suppliers</h3>
            <p className={classes.prgText}>Add, View, Edit and Delete Supplier.</p>
            </div>
            <div className={classes.subContainer}>            
            <div className={classes.laysbtns}>
                            <button className={classes.loanBtn} 
                            // onClick={handleShow}
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add New
                            </button>

                            <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button>

                            <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button> 
                          </div>

                          <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Suppliers Accounts</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div>

                         <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>

            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
                             <tr>
                              {/* <th>S/N</th> */}
                              <th>#</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone Number</th>
                              <th>Action</th>
                            </tr>
  </thead>
  <tbody>

  { benLoading ? (
    searchTerm ? (
      <tr>
        <td colSpan={5} style={{ textAlign: "center" }}>
          Fetching Suppliers...
        </td>
      </tr>
    ) : (
      Array(5).fill().map((_, idx) => (
        <tr key={idx}>
          {Array(5).fill().map((_, i) => (
            <td key={i}>
              <Skeleton height={20} style={{ marginBottom: 10 }} />
            </td>
          ))}
        </tr>
      ))
    )
  ) : (
    displayedData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{item.name}</td>
        <td className={classes.textby}>{item.email}</td>
        <td className={classes.textby}>{item.phone_number}</td>
        <td className={classes.btnAction}>
          <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to upload account</Tooltip>}
          >

          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handleUploadShow2(item)} // add item.id
          >
            <FaFileUpload style={{ color: "#092147", borderColor: "#dc35454d", borderRadius: 5, fontSize: 19, cursor: "pointer" }} />
          </button>
        </OverlayTrigger>
          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handleShow1(item)} // add item.id
          >
            <img src={EyeIcon} />
          </button>
          <button
            onClick={() => handleTrashClick(item.id)}
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
          >
            <img src={DeleteIcon} />
          </button>
        </td>
      </tr>
    ))
  )
}
  </tbody>
  {!benLoading && searchTerm && displayedData.length === 0 && (
  <tbody>
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}>
        No Suppliers found
      </td>
    </tr>
  </tbody>
)}

</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default SuppliersAccount